import { render, staticRenderFns } from "./ResendVerificationCodeForm.vue?vue&type=template&id=9e7b6aea&"
import script from "./ResendVerificationCodeForm.vue?vue&type=script&lang=js&"
export * from "./ResendVerificationCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports